import axios from 'axios'
import { useAppDataStore } from '@/stores/app-data'
import router from '@/router'

export const handleError = (error: any) => {
  if (axios.isCancel(error)) return;

  const store = useAppDataStore();

  // console.debug(error);
  if (error?.message) {
    console.error("❌ ERROR:", error);
    store.$patch({
      notifications: {
        errors: [
            ...store.notifications.errors,
            error.message,
        ],
      }
    })
  }
}

export const setCookie = (name: string, value: string) => {
    document.cookie = name + '=' + value;
}

export const clearCookie = (name: string) => {
    document.cookie = document.cookie.split(';')
        .filter((cookie: string) => {
            return !cookie.includes(cookieName)
        })
        .join(';');
}

export const stripHtml = (html: string|null) => {
  let tmp = document.createElement("DIV");
  tmp.innerHTML = html ?? "";
  return tmp.textContent || tmp.innerText || "";
}

// A modification summary a user types is plain text. The choice prompt renders summaries as HTML
// because CMS entries arrive with markup, so anything authored in the app is reduced to its text
// before it is stored; an emptied field is null, never ''.
export const plainText = (value: string | null | undefined): string | null => {
  const text = stripHtml(value ?? '').trim();
  return text.length > 0 ? text : null;
}

export const deepCopyObject = <T>(instance : T) : T => {
  if (instance === null) {
    return instance;
  }

  // handle Dates
  if (instance instanceof Date) {
    return new Date(instance.getTime()) as any;
  }

  // handle Array types
  if (instance instanceof Array){
    var cloneArr = [] as any[];
    (instance as any[]).forEach((value)  => {cloneArr.push(value)});
    // for nested objects
    return cloneArr.map((value: any) => deepCopyObject<any>(value)) as any;
  }
  // handle objects
  if (instance instanceof Object) {
    var copyInstance = { ...(instance as { [key: string]: any }
      ) } as { [key: string]: any };
    for (var attr in instance) {
      if ( (instance as Object).hasOwnProperty(attr))
        copyInstance[attr] = deepCopyObject<any>(instance[attr]);
    }
    return copyInstance as T;
  }
  // handling primitive data types
  return instance;
}

export const slugify = (input: string): string => {
    const camel = input
        .trim()
        .replace(/[^a-zA-Z0-9\s]/g, '')
        .split(/\s+/)
        .filter(Boolean)
        .map((word, i) => (i === 0
            ? word.charAt(0).toLowerCase() + word.slice(1)
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
        .join('')
    return camel || 'attribute'
}

// App.vue renders every toast with v-html, so text that came from a user (an element or world name)
// must be escaped before it is formatted into one. Vue escapes text and attribute bindings itself;
// this is only for strings that end up inside v-html.
export const escapeHtml = (text: string): string =>
    text.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch] as string));

export const SAVED_ROUTE_KEY = 'savedRoute';

export const redirectToSavedRoute = () => {
  const savedRoute = sessionStorage.getItem(SAVED_ROUTE_KEY);
  if (savedRoute) {
    sessionStorage.removeItem(SAVED_ROUTE_KEY);
    router.push(savedRoute);
  } else {
    router.push({ name: 'home' });
  }
}
